import React, { useState, useEffect } from 'react';
import './Mould.css';
import mixerMotor from '../../images/mixermotor.png';
import actuator from '../../images/actuator.png';
import SevenSegmentDisplay from '../SevenSegmentStyle/SevenSegmentDisplay';
import NavigationButtons from '../NavigationButtons/NavigationButtons';

const Mould = () => {
  const [activeTab, setActiveTab] = useState('design');
  const [data, setData] = useState({
    Mixer_Motor_Speed: '0.00',
    Sand_in_Hopper: '0.00',
    Discharge_Sand: '0.00',
    Set_Sand_Discharge_Value: '0.00',
    Mixer_Motor_Direction_CW_or_CCW: '1',
    Pattern_Holder_Actuator_Forward: '1',
    Pattern_Holder_Actuator_Reverse: '0',
    Supporting_Actuator_UP: '0',
    Supporting_Actuator_DOWN: '0',
    Mould_Eject_Actuator_Forward: '0',
    Mould_Eject_Actuator_Reverse: '0',
    Drag_Ram_Plate_Forward: '0',
    Drag_Ram_Plate_Reverse: '0',
    Drag_Mould_Box_Open: '0',
    Drag_Mould_Box_Close: '0',
    Cope_Mould_Box_Open: '0',
    Cope_Mould_Box_Close: '0',
    Sand_Discharge_Valve_Open_or_Close: '0',
    Sand_Flushing_Door_Open: '0',
    Sand_Flushing_Door_Close: '0',
    Mixed_Sand_Discharge_Open: '0',
    Mixed_Sand_Discharge_Close: '0',
    Cope_Ram_Plate_Forward: '0',
    Cope_Ram_Plate_Reverse: '0',
    Part_A_Open : '1',
    Part_B_Open : '0',
    Part_C_Open : '0',
    Pattern_Forward: '0',
    Pattern_Reverse: '0',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://cmti-edge.online/foundry/php/smartfoundry.php');
        const jsonData = await response.json();
        setData(jsonData);
      } catch (error) {
        console.error('Failed to fetch data:', error);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 1000);

    return () => clearInterval(interval);
  }, []);

  const updateToggleButton = (value) => {
    return value === '1';
  };

  const updateLED = (value) => {
    return value === '1' || value === 1 ? 'green' : 'red';
  };

  return (
    <div>
      <div className="header">MOULD MAKING UNIT</div>
      <div className="flex flex-col bg-gray-200 lg:flex-row">
        <div className="flex bg-gray-200 justify-center w-full items-center">
          <NavigationButtons />
        </div>
        <div className="flex flex-wrap bg-gray-200 justify-center p-4 actives_buttons gap-4 lg:justify-end">
          <button className="btns transparent" onClick={() => setActiveTab('design')}>MIXER MOTOR UNIT</button>
          <button className="btns transparent" onClick={() => setActiveTab('actuator')}>ACTUATOR</button>
          <button className="btns transparent" onClick={() => setActiveTab('parameters')}>PROCESS PARAMETERS</button>
        </div>
      </div>

      <div className={`container_one ${activeTab === 'design' ? 'active_tab' : ''}`}>
        <div className="container_two">
          <div className="main_contents">

            {activeTab === 'design' && (
              <form className="melt_one">
                <div className="active tab-content">
                  <div className="flex-container">

                    <div className="content-right">
                      <div className="parameters">
                        <h2 className="">Mixer Motor Speed (RPM)</h2>
                        <SevenSegmentDisplay value={data.Mixer_Motor_Speed} />
                      </div>
                      <div className="parameters">
                        <h2 className="">Mixer Motor Direction CW / CCW</h2>
                        <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Mixer_Motor_Direction_CW_or_CCW) }}></div>
                      </div>
                      <div className="parameters">
                        <h2 className="">Sand in Hopper (Kg)</h2>
                        <SevenSegmentDisplay value={data.Sand_in_Hopper} />
                      </div>
                      <div className="parameters">
                        <h2 className="">Discharge Sand (Kg)</h2>
                        <SevenSegmentDisplay value={data.Discharge_Sand} />
                      </div>
                      <div className="parameters">
                        <h2 className="">Set Sand Discharge Value (Kg)</h2>
                        <SevenSegmentDisplay value={data.Set_Sand_Discharge_Value} />
                      </div>
                      
                    </div>


                  </div>
                </div>
              </form>
            )}

            {activeTab === 'actuator' && (
              <form className="pour_one">
                <div className="tab-content">
                  <div className="flex-container">
                    <div className="grid grid-cols-1 p-4 content-right gap-2 lg:grid-cols-3 narrow-content-right sm:grid-cols-2">
                      {/* <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 parameter transform transition">
                        <h2 className="font-semibold mb-2">Pattern Forward</h2>
                        <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Pattern_Forward) }}></div>
                      </div>
                      <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 parameter transform transition">
                        <h2 className="text-xl font-semibold mb-2">Pattern Reverse</h2>
                        <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Pattern_Reverse) }}></div>
                      </div> */}
                      <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 parameter transform transition">
                        <h2 className="text-xl font-semibold mb-2">Pattern Holder Actuator Forward</h2>
                        <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Pattern_Holder_Actuator_Forward) }}></div>
                      </div>
                      <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 parameter transform transition">
                        <h2 className="text-xl font-semibold mb-2">Pattern Holder Actuator Reverse</h2>
                        <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Pattern_Holder_Actuator_Reverse) }}></div>
                      </div>
                      <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 parameter transform transition">
                        <h2 className="text-xl font-semibold mb-2">Supporting Actuator Up</h2>
                        <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Supporting_Actuator_UP) }}></div>
                      </div>
                      <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 parameter transform transition">
                        <h2 className="text-xl font-semibold mb-2">Supporting Actuator Down</h2>
                        <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Supporting_Actuator_DOWN) }}></div>
                      </div>

                      <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 parameter transform transition">
                        <h2 className="text-xl font-semibold mb-2">Part-A Open/Close</h2>
                        <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Part_A_Open) }}></div>
                      </div>
                      <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 parameter transform transition">
                        <h2 className="text-xl font-semibold mb-2">Part-B Open/Close</h2>
                        <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Part_B_Open) }}></div>
                      </div>
                      <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 parameter transform transition">
                        <h2 className="text-xl font-semibold mb-2">Part-C Open/Close</h2>
                        <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Part_C_Open) }}></div>
                      </div>
                      {/* <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 parameter transform transition">
                        <h2 className="text-xl font-semibold mb-2">Mould Eject Actuator Forward</h2>
                        <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Mould_Eject_Actuator_Forward) }}></div>
                      </div>
                      <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 parameter transform transition">
                        <h2 className="text-xl font-semibold mb-2">Mould Eject Actuator Reverse</h2>
                        <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Mould_Eject_Actuator_Reverse) }}></div>
                      </div> */}
                      {/* <div className="parameters">
                    <h2>Part-A Open/Close</h2>
                    <div
                      className={`led-indicator ${updateToggleButton(data.Part_A_Open) ? "on" : ""
                        }`}
                    ></div>
                  </div>
                  <div className="parameters">
                    <h2>Part-B Open/Close</h2>
                    <div
                      className={`led-indicator ${updateToggleButton(data.Part_B_Open) ? "on" : ""
                        }`}
                    ></div>
                  </div>
                  <div className="parameters">
                    <h2>Part-C Open/Close</h2>
                    <div
                      className={`led-indicator ${updateToggleButton(data.Part_C_Open) ? "on" : ""
                        }`}
                    ></div>
                  </div> */}
                    </div>
                  </div>
                </div>
              </form>
            )}

            {activeTab === 'parameters' && (
              <div className="mould_parameter_cards">
                <div className="grid grid-cols-1 p-4 gap-6 lg:grid-cols-3 mould_tab_contents sm:grid-cols-2">
                  <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 mould_parameter transform transition">
                    <h2 className="text-xl font-semibold mb-2">Drag Ram Plate Forward</h2>
                    <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Drag_Ram_Plate_Forward) }}></div>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 mould_parameter transform transition">
                    <h2 className="text-xl font-semibold mb-2">Drag Ram Plate Reverse</h2>
                    <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Drag_Ram_Plate_Reverse) }}></div>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 mould_parameter transform transition">
                    <h2 className="text-xl font-semibold mb-2">Drag Mould Box Open</h2>
                    <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Drag_Mould_Box_Open) }}></div>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 mould_parameter transform transition">
                    <h2 className="text-xl font-semibold mb-2">Drag Mould Box Close</h2>
                    <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Drag_Mould_Box_Close) }}></div>
                  </div>
                  {/* <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 mould_parameter transform transition">
                    <h2 className="text-xl font-semibold mb-2">Cope Mould Box Open</h2>
                    <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Cope_Mould_Box_Open) }}></div>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 mould_parameter transform transition">
                    <h2 className="text-xl font-semibold mb-2">Cope Mould Box Close</h2>
                    <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Cope_Mould_Box_Close) }}></div>
                  </div> */}
                  {/* <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 mould_parameter transform transition">
                    <h2 className="text-xl font-semibold mb-2">Sand Discharge Valve Open / Close</h2>
                    <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Sand_Discharge_Valve_Open_or_Close) }}></div>
                  </div> */}
                  {/* <div className="col-span-full bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 lg:col-span-2 mould_parameter transform transition">
                    <h2 className="text-xl font-semibold mb-2">Sand Flushing Door Open</h2>
                    <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Sand_Flushing_Door_Open) }}></div>
                  </div>
                  <div className="col-span-full bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 lg:col-span-2 mould_parameter transform transition">
                    <h2 className="text-xl font-semibold mb-2">Sand Flushing Door Close</h2>
                    <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Sand_Flushing_Door_Close) }}></div>
                  </div> */}
                  <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 mould_parameter transform transition">
                    <h2 className="text-xl font-semibold mb-2">Mixed Sand Discharge Open</h2>
                    <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Mixed_Sand_Discharge_Open) }}></div>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 mould_parameter transform transition">
                    <h2 className="text-xl font-semibold mb-2">Mixed Sand Discharge Close</h2>
                    <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Mixed_Sand_Discharge_Close) }}></div>
                  </div>
                  {/* <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 mould_parameter transform transition">
                    <h2 className="text-xl font-semibold mb-2">Cope Ram Plate Forward</h2>
                    <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Cope_Ram_Plate_Forward) }}></div>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-lg duration-300 ease-in-out hover:scale-105 mould_parameter transform transition">
                    <h2 className="text-xl font-semibold mb-2">Cope Ram Plate Reverse</h2>
                    <div className="h-6 rounded-full w-6 led-indicator" style={{ backgroundColor: updateLED(data.Cope_Ram_Plate_Reverse) }}></div>
                  </div> */}
                </div>
              </div>
            )}
          </div>

          <div className="panels-container">
            <div className="left-panel panel">
              <div className="left_content">
                <div className="pour_card">
                  <img src={mixerMotor} alt="Mixer Motor" className="motor_image" />
                </div>
                <h1>Front View of Mixer Motor</h1>
              </div>
            </div>
            <div className="panel right-panel">
              <div className="right_content">
                <img src={actuator} alt="Actuator" className="motor_image" />
                <h2>Front View of Actuator</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex bg-[#141622] h-[70px] justify-center text-center text-sm text-white w-full items-center lg:text-xl md:text-lg sm:text-base">
        <p>
          Central Manufacturing Technology Institute, Tumkur Road, Bengaluru-560022, Karnataka, India © 2024 CMTI All rights reserved. ||
          <a href="https://example.com" className="hover:underline mx-2">Terms and Conditions</a>
        </p>
      </div>
    </div>
  );
};

export default Mould;
